module.exports = __webpack_public_path__ + "img/03-424-424.98ab9994.png";